<div class="admin-ppas">
  <h1 id="ppas-table-heading" class="mb-4 text-2xl font-semibold text-gray-800">PPAs</h1>

  <div class="table-card">
    <div class="table-toolbar">
      <div class="table-toolbar__filters">
        <mat-form-field appearance="outline">
          <mat-label>Search</mat-label>
          <mat-icon matPrefix class="mr-2 text-gray-400">search</mat-icon>
          <input matInput [formControl]="searchControl" placeholder="Name or type…" />
        </mat-form-field>
      </div>
    </div>

    <table mat-table [dataSource]="ppas" aria-labelledby="ppas-table-heading">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>PPA</th>
        <td mat-cell *matCellDef="let p">
          <div class="cell-identity__primary">
            <a [routerLink]="['/ppa', p.slug_id]" target="_blank" class="ppa-link">{{ p.name }}</a>
          </div>
          <div class="cell-identity__secondary">{{ p.type_of_ppa }} · ID {{ p.id }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="place">
        <th mat-header-cell *matHeaderCellDef>Place</th>
        <td mat-cell *matCellDef="let p">{{ ppaPlace(p.Locations?.[0]) || '—' }}</td>
      </ng-container>
      <ng-container matColumnDef="reviews">
        <th mat-header-cell *matHeaderCellDef>Reviews</th>
        <td mat-cell *matCellDef="let p"><span class="table-chip">{{ p.review_count }}</span></td>
      </ng-container>
      <ng-container matColumnDef="corpers">
        <th mat-header-cell *matHeaderCellDef>Corp members</th>
        <td mat-cell *matCellDef="let p"><span class="table-chip">{{ p.corper_count }}</span></td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let p">
          <div class="table-actions">
            <button
              type="button"
              class="table-icon-btn table-icon-btn--danger"
              (click)="removePpa(p)"
              [disabled]="busyIds.has(p.id)"
              [attr.aria-label]="'Remove ' + p.name"
              matTooltip="Merge or delete"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="columns"></tr>
      <tr mat-row *matRowDef="let row; columns: columns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell py-4 text-center text-gray-500" [attr.colspan]="columns.length">
          <span *ngIf="loading">Loading…</span>
          <span *ngIf="!loading && ppas.length === 0">No PPAs found</span>
        </td>
      </tr>
    </table>
    <mat-paginator
      [length]="total"
      [pageIndex]="page - 1"
      [pageSize]="limit"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="true"
      (page)="onPageChange($event)"
    ></mat-paginator>
  </div>

  <div class="table-card mt-8">
    <div class="table-toolbar">
      <div>
        <h2 id="deleted-ppas-heading" class="table-toolbar__heading">Recently deleted</h2>
        <p class="deleted-hint">Removed for good, with their reviews, {{ retention }} after they're deleted. Restore one to bring it back as it was - a merged duplicate can't be, everything on it moved.</p>
      </div>
      <div class="table-toolbar__actions">
        <mat-form-field appearance="outline" class="category-filter">
          <mat-label>Why</mat-label>
          <mat-select [formControl]="categoryControl">
            <mat-option value="">All reasons</mat-option>
            <mat-option *ngFor="let c of categories" [value]="c.value">{{ categoryOption(c) }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>
    <table mat-table [dataSource]="deleted" aria-labelledby="deleted-ppas-heading">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>PPA</th>
        <td mat-cell *matCellDef="let p">
          <div class="cell-identity__primary">{{ p.name }}</div>
          <div class="cell-identity__secondary">{{ p.type_of_ppa }} · {{ ppaPlace(p.Locations?.[0]) || 'No place' }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="reason">
        <th mat-header-cell *matHeaderCellDef>Why</th>
        <td mat-cell *matCellDef="let p" class="reason-cell">
          <span class="table-chip">{{ categoryLabel(p.deletion_category) }}</span>
          <div *ngIf="p.MergedInto" class="merged-into">
            Merged into <a [routerLink]="['/ppa', p.MergedInto.slug_id]" target="_blank">{{ p.MergedInto.name }}</a>
          </div>
          <div *ngIf="p.deletion_reason" class="reason-note">{{ p.deletion_reason }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="deleted">
        <th mat-header-cell *matHeaderCellDef>Deleted</th>
        <td mat-cell *matCellDef="let p">
          <div>{{ p.deleted_at | date: 'mediumDate' }}</div>
          <div class="cell-identity__secondary" *ngIf="p.DeletedBy">by {{ p.DeletedBy.username }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="purges">
        <th mat-header-cell *matHeaderCellDef>Gone for good</th>
        <td mat-cell *matCellDef="let p">{{ p.purges_at | date: 'mediumDate' }}</td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let p">
          <div class="table-actions">
            <button
              *ngIf="!p.MergedInto"
              type="button"
              class="table-icon-btn"
              (click)="restorePpa(p)"
              [disabled]="busyIds.has(p.id)"
              [attr.aria-label]="'Restore ' + p.name"
              matTooltip="Restore"
            >
              <mat-icon>restore_from_trash</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="deletedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: deletedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell py-4 text-center text-gray-500" [attr.colspan]="deletedColumns.length">
          <span *ngIf="loadingDeleted">Loading…</span>
          <span *ngIf="!loadingDeleted && deleted.length === 0">No PPAs deleted in the last {{ retention }}</span>
        </td>
      </tr>
    </table>
    <mat-paginator
      [length]="totalDeleted"
      [pageIndex]="deletedPage - 1"
      [pageSize]="deletedLimit"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="true"
      (page)="onDeletedPageChange($event)"
    ></mat-paginator>
  </div>

  <div class="table-card mt-8">
    <div class="table-toolbar">
      <div>
        <h2 id="blocked-ppa-names-heading" class="table-toolbar__heading">Blocked names</h2>
        <p class="deleted-hint">Nobody can add a PPA with these names, however they spell them.</p>
      </div>
    </div>
    <table mat-table [dataSource]="blockedNames" aria-labelledby="blocked-ppa-names-heading">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>Name</th>
        <td mat-cell *matCellDef="let b"><div class="cell-identity__primary">{{ b.name }}</div></td>
      </ng-container>
      <ng-container matColumnDef="reason">
        <th mat-header-cell *matHeaderCellDef>Why</th>
        <td mat-cell *matCellDef="let b" class="reason-cell">{{ b.reason || '—' }}</td>
      </ng-container>
      <ng-container matColumnDef="blocked">
        <th mat-header-cell *matHeaderCellDef>Blocked</th>
        <td mat-cell *matCellDef="let b">
          <div>{{ b.created_at | date: 'mediumDate' }}</div>
          <div class="cell-identity__secondary" *ngIf="b.BlockedBy">by {{ b.BlockedBy.username }}</div>
        </td>
      </ng-container>
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let b">
          <div class="table-actions">
            <button
              type="button"
              class="table-icon-btn"
              (click)="unblockName(b)"
              [disabled]="busyBlockedIds.has(b.id)"
              [attr.aria-label]="'Unblock ' + b.name"
              matTooltip="Unblock"
            >
              <mat-icon>lock_open</mat-icon>
            </button>
          </div>
        </td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="blockedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: blockedColumns"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell py-4 text-center text-gray-500" [attr.colspan]="blockedColumns.length">
          <span *ngIf="loadingBlocked">Loading…</span>
          <span *ngIf="!loadingBlocked && blockedNames.length === 0">No blocked names</span>
        </td>
      </tr>
    </table>
    <mat-paginator
      [length]="totalBlocked"
      [pageIndex]="blockedPage - 1"
      [pageSize]="blockedLimit"
      [pageSizeOptions]="pageSizeOptions"
      [showFirstLastButtons]="true"
      (page)="onBlockedPageChange($event)"
    ></mat-paginator>
  </div>
</div>
